import { css } from 'styled-components';

export function getIconCss(icon, icon2x, width, height) {
  return css`
    display: inline-block;
    vertical-align: middle;
    width: ${width}px;
    height: ${height}px;
    background-image: url(${icon});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100%;

    @media only screen and (-webkit-min-device-pixel-ratio: 2),
      only screen and (min--moz-device-pixel-ratio: 2),
      only screen and (-o-min-device-pixel-ratio: 2/1),
      only screen and (min-device-pixel-ratio: 2),
      only screen and (min-resolution: 192dpi),
      only screen and (min-resolution: 2dppx) {
      background-image: url(${icon2x});
    }
  `;
}
